module.exports = __webpack_public_path__ + "static/media/YF90_3.d7bf4dcd.jpg";